import {
    apiTransitionBenefitsAfrica,
    apiTransitionBenefitsAsia,
    apiTransitionBenefitsEurope,
    apiTransitionBenefitsPilgrimage,
    apiTransitionBenefitsStudents,
    apiTransitionBenefitsWorldWide,
    fetchBenefitsAfricaSuccess,
    fetchBenefitsAsiaSuccess,
    fetchBenefitsEuropeSuccess,
    fetchBenefitsPilgrimageSuccess,
    fetchBenefitsStudentSuccess,
    fetchBenefitsWorldWideSuccess,
} from '../../../actions/travelKe/quote';
import { getAccessToken } from '../../../selectors/travelKe/payments';
import axios from 'axios';
import { getPremiumCalculation } from '../../../selectors/travelKe/quote';

const getBenefits = async (cover, plan, state, quoteId) => {
    const loginData = getAccessToken(state);
    const url = `om-api/travel-ke/benefits?cover=${cover}&plan=${plan}&quoteId=${quoteId}`;
    try {
        return await axios.get(url, {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(`Error fetching benefits for ${cover}/${plan}:`, e);
        throw e;
    }
};

const benefitPlans = [
    {
        cover: 'retail',
        plan: 'europe',
        successAction: fetchBenefitsEuropeSuccess,
        apiTransition: apiTransitionBenefitsEurope,
    },
    {
        cover: 'retail',
        plan: 'worldwide',
        successAction: fetchBenefitsWorldWideSuccess,
        apiTransition: apiTransitionBenefitsWorldWide,
    },
    {
        cover: 'retail',
        plan: 'africa',
        successAction: fetchBenefitsAfricaSuccess,
        apiTransition: apiTransitionBenefitsAfrica,
    },
    {
        cover: 'retail',
        plan: 'asia',
        successAction: fetchBenefitsAsiaSuccess,
        apiTransition: apiTransitionBenefitsAsia,
    },
    {
        cover: 'student',
        plan: 'classic',
        successAction: fetchBenefitsStudentSuccess,
        apiTransition: apiTransitionBenefitsStudents,
    },
    {
        cover: 'pilgrimage',
        plan: 'basic',
        successAction: fetchBenefitsPilgrimageSuccess,
        apiTransition: apiTransitionBenefitsPilgrimage,
    },
];

export const getBenefitsService = (store, next, action) => {
    const quoteId = getPremiumCalculation(store.getState()).value?.id;

    (async () => {
        benefitPlans.forEach((p) => store.dispatch(p.apiTransition.pending()));

        try {
            const responses = await Promise.all(
                benefitPlans.map((p) => getBenefits(p.cover, p.plan, store.getState(), quoteId))
            );

            responses.forEach((resp, index) => {
                const { successAction, apiTransition } = benefitPlans[index];
                store.dispatch(successAction(resp.data));
                store.dispatch(apiTransition.success());
            });
        } catch (e) {
            console.error('An error occurred during benefits fetching:', e);
            benefitPlans.forEach((p) => store.dispatch(p.apiTransition.failure()));
        }
    })();

    return next(action);
};
